<template>
  <first-page>
    <create-password-form/>
  </first-page>
</template>

<script>
import FirstPage from "@/components/pages/FirstPage";
import CreatePasswordForm from "@/components/login/CreatePasswordForm";

export default {
  name: "SetPasswordPage",
  components: {CreatePasswordForm, FirstPage}
}
</script>

<style scoped>

</style>
